import { Form, Input } from "decorator-form";
import InputType from "common/form/InputType";

@Form({ title: "LearningSummary Config" })
export default class LearningSummaryConfig {
	@Input({ type: InputType.CHECKBOX, title: "Enable Refine" })
	public enableRefine?: boolean;

	@Input({ type: InputType.TEXT, title: "Credit Type Ids" })
	public creditTypeIds: string;

	@Input({ type: InputType.CHECKBOX, title: "Enable YTD Completion" })
	public enableYTDCompletion?: boolean;

	@Input({ type: InputType.CHECKBOX, title: "Enable Total Completion" })
	public enableTotalCompletion?: boolean;

	@Input({ type: InputType.CHECKBOX, title: "YTD Credits" })
	public enableYTDCredits?: boolean;

	@Input({ type: InputType.CHECKBOX, title: "Total Credits" })
	public enableTotalCredits?: boolean; 

	@Input({ type: InputType.NUMBER, title: "Fraction Digits" })
	public fractionDigits: number=2;
}



// WEBPACK FOOTER //
// ./src/panels/learningSummary/LearningSummaryConfig.ts